import type React from 'react';
import type { FC, PropsWithChildren } from 'react';

import { ScInputStructure } from './styled';

export interface InputStructureProps extends PropsWithChildren {
  error?: React.ReactNode;
  disabled?: boolean;
  hideErrorMessage?: boolean;
  infoMessage?: string | JSX.Element;
  addons?: JSX.Element;
  withTick?: boolean;
}

export const InputStructure: FC<InputStructureProps> = ({
  error,
  hideErrorMessage = false,
  infoMessage,
  children,
  addons,
  withTick,
  ...props
}) => (
  <ScInputStructure {...props}>
    <div className="content">
      {children}
      {(addons || withTick) && (
        <div className="addons">
          {withTick && (
            <div className={`icon ${error ? 'error-icon' : 'success-icon'}`} />
          )}

          {addons}
        </div>
      )}
    </div>
    {!hideErrorMessage && !!error ? (
      <div className="error">{error}</div>
    ) : (
      infoMessage && <div className="info">{infoMessage}</div>
    )}
  </ScInputStructure>
);
